import { Component, inject } from '@angular/core';
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  NavigationEnd,
  Router,
  RouterOutlet
} from '@angular/router';
import { filter, map, startWith } from 'rxjs';
import { AsyncPipe } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';

/**
 * Layout component for authenticated pages with header bar
 */
@Component({
  selector: 'app-header-page-layout',
  imports: [RouterOutlet, AsyncPipe, TranslocoPipe],
  templateUrl: './header-page-layout.component.html',
  styleUrl: './header-page-layout.component.scss'
})
export class HeaderPageLayoutComponent {
  private router = inject(Router);
  private readonly activatedRoute = inject(ActivatedRoute);

  title$ = this.router.events.pipe(
    startWith(this.activatedRoute.snapshot),
    filter((event) => {
      return event instanceof NavigationEnd || event instanceof ActivatedRouteSnapshot;
    }),
    map(() => {
      let route: ActivatedRouteSnapshot = this.router.routerState.snapshot.root;
      let title = '';
      while (route.children.length > 0) {
        route = route.firstChild!;

        if (route.data['titleKey']) {
          title = route.data['titleKey'];
        }
      }
      return title;
    })
  );
}
